const Contact = () => {
    return (
        <div className="contact py-10 pt-[98px] md:pt-[128px]">
      <div className="container">
        <img className='banner-img mb-5' src="https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto/portal/m/seo/Food_collectionbanner.png" alt="banner" />
        <h2 className="text-3xl font-bold whitespace-nowrap mb-4">Contact Us</h2>
        <h4 className="text-xl font-bold mb-4">Lorem ipsum dolor sit amet consectetur adipisicing elit. Quidem, mollitia!</h4>
        <p className="text-lg mb-4">Lorem ipsum dolor sit, amet consectetur adipisicing elit. Excepturi vel sequi, consequuntur quisquam officia, omnis architecto labore molestias unde quod ullam necessitatibus rem tenetur! Ad ex repellat vel magnam ullam.</p>
        
      </div>
    </div>
    )
}

export default Contact